import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const UserGroup_xs = (props) => {
    const width = props.width ? props.width + 'px' : '16px';
    const height = props.height ? props.height + 'px' : '16px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 16 16"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.9535 6.7506C11.9842 6.50472 12 6.25421 12 6.00002C12 5.74613 11.9843 5.49593 11.9536 5.25034C11.9691 5.25012 11.9845 5.25002 12 5.25002C13.747 5.25002 15.2045 6.62777 15.2045 8.37737C15.2045 9.44127 14.6656 10.3677 13.8504 10.9304C14.6324 11.2986 15.2451 11.8996 15.655 12.6348C15.8568 12.9965 15.727 13.4533 15.3652 13.6551C15.0035 13.8568 14.5467 13.727 14.3449 13.3653C13.9057 12.5776 13.1237 12.033 12 12.033C11.6541 12.033 11.3406 12.0846 11.0595 12.179C10.8312 11.6644 10.3929 11.2637 9.85332 11.0856C9.94918 11.0301 10.048 10.9783 10.1496 10.9304C10.0248 10.8443 9.90647 10.7496 9.79555 10.6472C10.1838 10.3297 10.5315 9.96455 10.8298 9.56064C11.1317 9.83412 11.5404 10.0047 12 10.0047C12.9642 10.0047 13.7045 9.25373 13.7045 8.37737C13.7045 7.50102 12.9642 6.75002 12 6.75002C11.9844 6.75002 11.969 6.75021 11.9535 6.7506Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.72731 3.05579C4.00541 3.05579 2.60953 4.45166 2.60953 6.17357C2.60953 7.89547 4.00541 9.29135 5.72731 9.29135C7.44921 9.29135 8.84509 7.89547 8.84509 6.17357C8.84509 4.45166 7.44921 3.05579 5.72731 3.05579ZM1.10953 6.17357C1.10953 3.62324 3.17698 1.55579 5.72731 1.55579C8.27764 1.55579 10.3451 3.62324 10.3451 6.17357C10.3451 8.06886 9.20327 9.69747 7.57 10.409C9.15975 10.8791 10.3676 11.9549 11.1145 13.3378C11.3113 13.7023 11.1755 14.1573 10.811 14.3542C10.4465 14.551 9.99152 14.4151 9.79469 14.0506C9.02397 12.6236 7.64887 11.6509 5.72731 11.6509C3.80575 11.6509 2.43065 12.6236 1.65993 14.0506C1.4631 14.4151 1.00808 14.551 0.643624 14.3542C0.279166 14.1573 0.14328 13.7023 0.340113 13.3378C1.08699 11.9549 2.29487 10.8791 3.88462 10.409C2.25135 9.69747 1.10953 8.06886 1.10953 6.17357Z"
            />
        </SvgStyled>
    );
};

export default UserGroup_xs;
